if (!customElements.get('hbe-operations-alert')) {
  customElements.define('hbe-operations-alert', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.section = this.closest('.js-product');
        this.section?.addEventListener('on:variant:change', this.onVariant);
        return;
      }
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-alert-form]');
      this.fields = this.querySelector('fieldset');
      this.status = this.querySelector('[data-alert-status]');
      this.retry = this.querySelector('[data-alert-retry]');
      this.section = this.closest('.js-product');
      this.epoch = 0;
      this.querySelector('[data-alert-open]').addEventListener('click', () => {
        this.form.reset();
        this.form.hidden = false;
        this.dialog.showModal();
        this.loadTicket();
      });
      this.querySelector('[data-alert-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        this.epoch++;
        this.controller?.abort();
        this.fields.disabled = true;
      });
      this.retry.addEventListener('click', () => this.loadTicket());
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.onVariant = (event) => {
        if (event.target.closest('.js-product') !== this.section) return;
        const variant = event.detail && event.detail.variant;
        this.dialog.close();
        this.hidden = !variant || variant.available !== false;
        this.dataset.variant = variant ? String(variant.id) : '';
        const label = this.querySelector('[data-alert-variant]');
        label.textContent = variant?.title || '';
        label.hidden = !variant || variant.title === 'Default Title';
      };
      this.section?.addEventListener('on:variant:change', this.onVariant);
    }
    disconnectedCallback() {
      this.epoch++;
      this.controller?.abort();
      this.section?.removeEventListener('on:variant:change', this.onVariant);
    }
    handlePaused(response, result) {
      if (response.status !== 503 || result.message !== 'Stock alerts are being prepared. Please check back soon.') return false;
      this.status.textContent = '';
      this.retry.hidden = true;
      this.fields.disabled = true;
      return true;
    }
    async loadTicket() {
      const epoch = ++this.epoch;
      this.controller?.abort();
      this.controller = new AbortController();
      this.fields.disabled = true;
      this.retry.hidden = true;
      this.status.textContent = this.dataset.loading;
      const timer = setTimeout(() => this.controller.abort(), 15000);
      try {
        const url = new URL('https://hobbytech-operations.onrender.com/stock-alerts/storefront');
        url.searchParams.set('variant', this.dataset.variant);
        const response = await fetch(url, {credentials:'omit',signal:this.controller.signal});
        const result = await response.json();
        if (epoch !== this.epoch || !this.dialog.open) return;
        if (this.handlePaused(response, result)) return;
        if (!response.ok || !result.ok) {
          this.status.textContent = result.message || this.dataset.error;
          this.retry.hidden = false;
          return;
        }
        if (result.inStock) {
          this.status.textContent = this.dataset.available;
          this.form.hidden = true;
          return;
        }
        this.form.elements.ticket.value = result.ticket;
        await new Promise(resolve => setTimeout(resolve, 1600));
        if (epoch !== this.epoch || !this.dialog.open) return;
        this.status.textContent = '';
        this.fields.disabled = false;
        this.form.elements.email.focus();
      } catch {
        if (epoch !== this.epoch || !this.dialog.open) return;
        this.status.textContent = this.dataset.error;
        this.retry.hidden = false;
      } finally { clearTimeout(timer); }
    }
    async submit(event) {
      event.preventDefault();
      if (this.fields.disabled) return;
      const epoch = this.epoch;
      const body = new URLSearchParams(new FormData(this.form));
      this.fields.disabled = true;
      this.status.textContent = this.dataset.saving;
      const controller = new AbortController();
      this.controller = controller;
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('https://hobbytech-operations.onrender.com/stock-alerts/storefront', {
          method:'POST',credentials:'omit',body,signal:controller.signal
        });
        const result = await response.json();
        if (epoch !== this.epoch || !this.dialog.open) return;
        if (this.handlePaused(response, result)) return;
        this.status.textContent = result.message || this.dataset.error;
        if (response.ok && (result.ok || result.inStock)) this.form.hidden = true;
        else this.fields.disabled = false;
      } catch {
        if (epoch !== this.epoch || !this.dialog.open) return;
        this.status.textContent = this.dataset.error;
        this.fields.disabled = false;
      } finally { clearTimeout(timer); }
    }
  });
}
